import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { SearchCriminal1 } from "../../../_components/searchCriminal1";
import { LanguageContext } from "../../../context/LanguageContext";

export const SearchByCrimeCount = (props) => {
  const [criminalData, setCriminalData] = useState([]);
  const [criminalHeaders, setCriminalHeaders] = useState([]);

  const { t } = useContext(LanguageContext);

  const requiredKeys = [
    "Sr.No",
    "name",
    "registernumber",
    "registernumberYear",
    "districtName",
  ];
  const requiredKeysTitle = [
    t("sr.no"),
    t("crime_number"),
    t("crime_year"),
    t("crime_police_station"),
    t("name"),
  ];

  useEffect(() => {
    console.log(" props.criminalRecords", props.criminalRecords);
    if (props.criminalRecords && props.criminalRecords) {
      // setCriminalRecors(props.criminalRecords.basicInfo);
      let columns1 =
        props.criminalRecords &&
        props.criminalRecords.map((itemObj, index) => {
          const year = itemObj.registernumberYear
            ? new Date(itemObj.registernumberYear).getFullYear()
            : null;
          return {
            ...itemObj,
            registernumberYear: year,
            districtName: `${itemObj.districtName || ""}(${
              itemObj.city_name
            })`.trim(),
            key: index + 1,
          };
        });

      // columns1 && columns1.length && columns1.reverse();
      console.log("columns1", columns1);

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
          "Sr.No": props.getSerialNumber(index, props.current, props.pageSize),
        };
      });
      setCriminalData(tempObj);

      let tablelabes = columns1 && columns1.length && Object.keys(columns1[0]);
      tablelabes && tablelabes.unshift("Sr.No");

      let tableColumns = [];
      tablelabes &&
        tablelabes.length &&
        tablelabes.forEach((item) => {
          if (
            _.filter(requiredKeys, function (o) {
              return o === item;
            }).length
          ) {
            tableColumns.push(item);
          }
        });

      let columnList = tableColumns.map((item, index) => {
        return {
          title: requiredKeysTitle[index],
          dataIndex: item,
          key: item,
        };
      });

      setCriminalHeaders(columnList);
    }
  }, [props.criminalRecords]);

  const onEditAccusedForm = (data) => {
    props.onEditAccusedForm(data);
  };
  const onViewAccusedForm = (data) => {
    props.onViewAccusedForm(data);
  };
  const onPreventiveViewAccusedForm = (data) => {
    props.onPreventiveViewAccusedForm(data);
  };

  return (
    <SearchCriminal1
      isAccusedFormUpdate={true}
      onEditAccusedForm={onEditAccusedForm}
      onViewAccusedForm={onViewAccusedForm}
      onPreventiveViewAccusedForm={onPreventiveViewAccusedForm}
      data={criminalData}
      columns={criminalHeaders}
      current={props.current}
      pageSize={props.pageSize}
      total={props.total}
      handlePageChange={props.handlePageChange}
      handlePageSizeChange={props.handlePageSizeChange}
      registernumber={props.registernumber}
      selectedPoliceStation={props.selectedPoliceStation}
      tableLoading={props.tableLoading}
      userid={props.userid}
      districtName={props.districtName}
      district={props.district}
    ></SearchCriminal1>
  );
};
